var textures = require('../textures');
export default textures;